import { render, staticRenderFns } from "./m-product-gallery-sfgallery.vue?vue&type=template&id=2da5cab4&scoped=true&"
import script from "./m-product-gallery-sfgallery.vue?vue&type=script&lang=js&"
export * from "./m-product-gallery-sfgallery.vue?vue&type=script&lang=js&"
import style0 from "./m-product-gallery-sfgallery.vue?vue&type=style&index=0&id=2da5cab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da5cab4",
  null
  
)

export default component.exports